import { AppBar, Link, Toolbar } from "@mui/material"
import { useTheme } from "@mui/material/styles"
import { Link as RouterLink } from "react-router"

import SvgIconStyle from "@sap/components/SvgIconStyle"
import Logo from "@sap/components/logo"
import { bgBlur } from "@sap/utils/cssStyles"

import { HEADER } from "../../config"

export default function Header({ isOffset }: { isOffset: boolean }) {
  const theme = useTheme()

  return (
    <AppBar color="transparent" sx={{ boxShadow: 0 }}>
      <Toolbar
        sx={{
          justifyContent: "space-between",
          height: {
            xs: HEADER.H_MOBILE,
            md: HEADER.H_MAIN_DESKTOP,
          },
          transition: theme.transitions.create(["height", "background-color"], {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.shorter,
          }),
          ...(isOffset && {
            ...bgBlur({ color: theme.palette.background.default }),
            height: {
              md: HEADER.H_MAIN_DESKTOP - 16,
            },
          }),
        }}
      >
        <Link to="/" component={RouterLink} sx={{ display: "contents" }}>
          <SvgIconStyle
            src="/assets/icons/satelliet_logo_small.svg"
            sx={{ width: 50, height: 50, color: theme.palette.text.primary }}
          />
        </Link>
        <Logo />
      </Toolbar>
    </AppBar>
  )
}
